import { Box, Paper, styled } from '@mui/material';

import useMyRotraTranslations from '$utils/useMyRotraTranslations';

import HighlightRow from './HighlightRow';

const StyledPaper = styled(Paper)(({ theme }) => ({
  borderColor: theme.palette.divider,
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
  '& > div': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

type PropTypes = {
  password: string;
};

export default function PasswordValidityHighlighter({ password }: PropTypes) {
  const { tSpecific } = useMyRotraTranslations({
    pathPrefix: 'activate_user',
  });

  return (
    <StyledPaper
      variant="outlined"
      sx={() => ({
        width: '100%',
      })}
    >
      <Box
        sx={{
          fontWeight: 700,
          fontSize: 16
        }}>
        {tSpecific('txt_password_requirements')}
      </Box>
      <HighlightRow
        password={password ?? ''}
        rule={/^.*(?=.{8,}).*$/}
        label={tSpecific('lbl_at_least_8_characters')}
      />
      <HighlightRow
        password={password}
        rule={/^.*((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/}
        label={tSpecific('lbl_at_least_one_lower_and_uppercase')}
      />
      <HighlightRow
        password={password}
        rule={/^.*(?=.*\d).*$/}
        label={tSpecific('lbl_at_least_one_number')}
      />
      <HighlightRow
        password={password}
        rule={/^.*((?=.*[!@#$%^&*]){1}).*$/}
        label={tSpecific('lbl_at_least_one_special_character')}
      />
    </StyledPaper>
  );
}
